import * as utils from 'Utils';


export function postIdentify(successCallback, errorCallback, token, data) {
  utils.postRq({
    "url": utils.buildUrl(`identify/${token}`),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

